var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserSupport = function SvgUserSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user-support_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.778.444a4.227 4.227 0 0 0-4.222 4.223c0 .737.196 1.466.546 2.067.051.164-.084.75-.352 1.017a.666.666 0 0 0 .436 1.137q.066.003.133.003c.558 0 1.21-.175 1.687-.393a4.2 4.2 0 0 0 1.77.392 4.227 4.227 0 0 0 4.222-4.223 4.226 4.226 0 0 0-4.22-4.223m-7.733 9.778a2.444 2.444 0 1 0 0-4.889 2.444 2.444 0 0 0 0 4.89m3.379 4.667H.667a.667.667 0 0 1-.634-.875 4.21 4.21 0 0 1 4.011-2.903 4.21 4.21 0 0 1 4.013 2.903.667.667 0 0 1-.633.875",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user-support_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgUserSupport;